import { useTranslations } from "use-intl";

import { GradeBadge } from "@/components/collection/grade-badge";

const gradeLabels: Record<string, string> = {
  mint: "Mint",
  near_mint: "NM",
  very_good_plus: "VG+",
  very_good: "VG",
  good_plus: "G+",
  good: "G",
  fair: "Fair",
  poor: "Poor",
};

export function OfferConditionDetails({
  details = { mediaGrade: null, sleeveGrade: null },
}: {
  details?: { mediaGrade: string | null; sleeveGrade: string | null };
}) {
  const t = useTranslations("shared.affiliates");
  const media = gradeLabels[details.mediaGrade ?? ""];
  const sleeve = gradeLabels[details.sleeveGrade ?? ""];
  if (media || sleeve)
    return (
      <span className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1">
          {t("usedGradeLabel", { kind: "media" })}
          {media ? <GradeBadge recordGrade={media} /> : "—"}
        </span>
        <span className="inline-flex items-center gap-1">
          {t("usedGradeLabel", { kind: "sleeve" })}
          {sleeve ? <GradeBadge sleeveGrade={sleeve} /> : "—"}
        </span>
      </span>
    );
  return <span className="text-xs text-muted-foreground">{t("conditionDetailsMissing")}</span>;
}
